import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBigPicklistInput, FDBodyText, FDDisplayText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('statusSelection', {
    _component: () => FDBigPicklistInput,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly);
